import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import SharedIcon from "../../assests/images/dashboard/share.png";
import Print from "../../assests/images/dashboard/print.png";
import CrossIcon from "../../assests/images/dashboard/Vector.png";
import { QRCode } from "react-qrcode-logo";
import Logo from "../common/Logo";
import { useReactToPrint } from "react-to-print";
import { useAuth } from "src/contexts/auth-provider";

const QrCodeModal = React.forwardRef((props: any, ref: React.Ref<any>) => {
  const { setQrCodeModal, restaurantId } = props;
  const contentRef = useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({ contentRef });
  const { hasRestaurant } = useAuth();

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setQrCodeModal?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [setQrCodeModal]);

  const modal = (
    <div aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div className="fixed inset-0 z-[100] flex min-h-0 items-center justify-center p-3 pt-[max(0.75rem,env(safe-area-inset-top,0px))] pb-[max(0.75rem,env(safe-area-inset-bottom,0px))] sm:p-4">
        <button
          type="button"
          tabIndex={-1}
          className="absolute inset-0 border-0 bg-black/60 p-0"
          aria-hidden
          onClick={setQrCodeModal}
        />
        <div
          ref={contentRef}
          className="modal-print relative z-10 max-h-[min(90dvh,calc(100dvh-env(safe-area-inset-top,0px)-env(safe-area-inset-bottom,0px)-1.5rem))] w-full max-w-[min(381px,calc(100vw-1.5rem))] overflow-y-auto overscroll-contain rounded-lg bg-white text-left shadow-xl"
        >
          <div className="relative flex flex-col items-center bg-gray-100">
            <div className="h-full w-full rounded-lg bg-orange p-8 shadow">
              <div className="relative text-center">
                <h1 className="text-sm text-[#FEFEFF85]">QR CODE</h1>
                <h1 className="text-2xl text-white">{hasRestaurant.name}</h1>
              </div>
            </div>
            <button
              type="button"
              className="absolute right-4 top-4 z-20 flex h-8 w-8 items-center justify-center rounded-lg hover:bg-white/10"
              onClick={setQrCodeModal}
              aria-label="Close"
            >
              <img src={CrossIcon} alt="" className="h-3 w-3" />
            </button>
            <div className="absolute top-[100px] rounded-xl bg-white">
              <div className="relative">
                <QRCode value={"eatsbits.com/restaurant/" + restaurantId} />
                <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white">
                  <Logo />
                </div>
              </div>
            </div>

            <div className="mt-28 flex flex-col items-center justify-center px-4 pb-8">
              <h1 id="modal-title" className="text-xl">
                Qr Code
              </h1>
              <div className="p-6">
                <p className="text-center text-sm text-[#666666]">
                  Utilize a barcode to give your customers quick and convenient access to your digital menu.
                </p>
              </div>

              <div className="print-exclude">
                <div className="flex flex-wrap justify-center gap-3">
                  <button
                    type="button"
                    onClick={() => handlePrint()}
                    className="flex h-[38px] items-center justify-center gap-2 rounded-xl bg-[#FD76571A] px-6 text-sm text-orange"
                  >
                    <img className="h-[15px] w-[15px]" src={Print} alt="" />
                    Print
                  </button>

                  <button
                    type="button"
                    className="flex h-[38px] items-center justify-center gap-2 rounded-xl bg-[#FD76571A] px-6 text-sm text-[#FD7657]"
                  >
                    <img className="h-[15px] w-[15px]" src={SharedIcon} alt="" />
                    Share
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  if (typeof document === "undefined") return null;
  return createPortal(modal, document.body);
});

export default QrCodeModal;
